$(function () {
  //ページが更新されたらソート情報をリセット
  localStorage.removeItem("sort");

  //ソート変更
  $(".js-archivesort").on("change", function () {
    localStorage.setItem("sort", $(this).val());
    loadposts($(this));
  });

  //ページ送りクリック
  $(".js-pager-btn").on("click", function () {
    loadposts($(this));
  });

  function loadposts(e) {
    //ソート情報の保存
    let ls_sort = "";
    ls_sort = localStorage.getItem("sort");

    //ソートに変更があればページ番号リセット
    if (ls_sort == e.val()) {
      params.current_page = 1;
    }

    //新着順の場合にソート情報のリセット
    if (ls_sort == "new") {
      localStorage.removeItem("sort");
    }

    const button = e,
      $btn_first = $(".js-pager-btn.first"),
      $btn_next = $(".js-pager-btn.next"),
      $btn_prev = $(".js-pager-btn.prev"),
      $btn_last = $(".js-pager-btn.last"),
      pagenum = button.data("num"),
      found_posts = {
        null: params.found_posts,
        new: params.found_posts,
        fav: params.fav_found_posts,
        view: params.view_found_posts,
      },
      max_page = {
        null: params.max_page,
        new: params.max_page,
        fav: params.fav_max_page,
        view: params.view_max_page,
      },
      data = {
        action: "loadmore",
        query: params.posts,
        page: pagenum,
        sort: ls_sort,
      };

    $.ajax({
      url: params.ajaxurl,
      data: data,
      type: "POST",
    })
      .then((...args) => {
        // done

        const [data, textStatus, jqXHR] = args;

        params.current_page = Number(params.current_page);

        if (button.hasClass("first")) {
          //最初
          params.current_page = 1;
          $btn_next.data("num", params.current_page + 1);
        }

        if (button.hasClass("prev")) {
          //前へ
          params.current_page--;
        }

        if (button.hasClass("next")) {
          //次へ
          params.current_page++;
        }

        if (button.hasClass("last")) {
          //最後
          params.current_page = max_page[ls_sort];
          $btn_prev.data("num", params.current_page - 1);
        }

        //前へと次へのページ番号を更新
        $btn_next.data("num", params.current_page + 1);
        $btn_prev.data("num", params.current_page - 1);
        $btn_last.data("num", max_page[ls_sort]);

        //1ページ10ページなので最初の番号は（ページ数 * 10 - 9）
        let range_first = params.current_page * 10 - 9;
        let range_last = "";

        //最後のページの場合
        if (params.current_page == max_page[ls_sort]) {
          if (found_posts[ls_sort] < 10) {
            range_first = 1;
          }
          range_last = found_posts[ls_sort];
          $btn_last.addClass("is-disable");
          $btn_next.addClass("is-disable");
          $btn_first.removeClass("is-disable");
          $btn_prev.removeClass("is-disable");
        }
        //最初のページの場合
        else if (params.current_page == 1) {
          range_last = params.current_page * 10;
          $btn_first.addClass("is-disable");
          $btn_prev.addClass("is-disable");
          $btn_next.removeClass("is-disable");
          $btn_last.removeClass("is-disable");
        }
        //2〜最終手前ページの場合
        else {
          range_last = params.current_page * 10;
          $btn_first.removeClass("is-disable");
          $btn_prev.removeClass("is-disable");
          $btn_next.removeClass("is-disable");
          $btn_last.removeClass("is-disable");
        }

        //現在の表示件数のレンジを出力
        $(".c-pager__total").text(`${range_first}〜${range_last} / ${found_posts[ls_sort]}`);

        //既存の投稿を削除
        $(".p-article__list").find(".p-article__card").remove();

        //リクエストした投稿を出力
        $(".p-article__list").append(data);
      })
      .catch((...args) => {
        // fail
        const [jqXHR, textStatus, errorThrown] = args;
        $(".p-article__list").append(
          '<p style="padding: 2.4em;background: #fff7b2;border: solid 1px #efefef;width: 100%;margin: 2em 0;">接続に失敗しました。ネットワーク環境をご確認ください。</p>'
        );
      })
      .then((data) => {
        // always
        //ローディング終了
      });
  }
});
